/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

import { NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { NgTemplateAssertType } from '@recruitee/common';
import type { RequisitionBrief } from '@recruitee/offers-types';
import { TruncateComponent } from '@recruitee/user-interface';

export interface RequisitionAccessConfig {
  hasAccessToAllRequisitions: boolean;
  hasAccessToRequisitionIds?: number[];
}

@Component({
  standalone: true,
  imports: [TruncateComponent, RouterLink, NgTemplateOutlet, NgTemplateAssertType],
  template: `
    <ng-template #requisitionTmpl [ngTemplateType]="RequisitionTemplateType" let-requisition>
      <a [routerLink]="['/requisitions', requisition.id]" (click)="$event.stopPropagation()">
        <rt-truncate>
          {{ requisition.title }}
        </rt-truncate>
      </a>
    </ng-template>

    <ng-template
      #requisitionRestrictedTmpl
      [ngTemplateType]="RequisitionTemplateType"
      let-requisition
    >
      <span>
        <rt-truncate>
          {{ requisition.title }}
        </rt-truncate>
      </span>
    </ng-template>

    @for (requisition of requisitions; track trackById($index, requisition)) {
      <ng-template
        [ngTemplateOutlet]="
          hasAccessToRequisition(requisition.id) ? requisitionTmpl : requisitionRestrictedTmpl
        "
        [ngTemplateOutletContext]="{ $implicit: requisition }"
      />
    }
  `,
  styleUrls: ['./requisition-cell.component.less'],
  host: {
    '[class]': '"requisitions-container"',
  },
  inputs: RequisitionsCellComponent.NgInputs,
})
export class RequisitionsCellComponent {
  public static NgInputs = ['requisitions' as const, 'requisitionAccessConfig' as const];
  public RequisitionTemplateType: { $implicit: RequisitionBrief };

  public requisitions: RequisitionBrief[];
  public requisitionAccessConfig: RequisitionAccessConfig;

  public hasAccessToRequisition(requisitionId: number): boolean {
    return (
      this.requisitionAccessConfig.hasAccessToAllRequisitions ||
      !!this.requisitionAccessConfig.hasAccessToRequisitionIds?.includes(requisitionId)
    );
  }

  public trackById = (index: number, item: RequisitionBrief) => item.id;
}
